import { OrderAction, OrderEvent } from '@oolio-group/domain';

// Shared by useCartEvent.ts and eventsByOrderIdReducer.ts — see OC-6580.
export function isForeignLoneInitiate(
  currentOrderId: string | undefined,
  incomingEvents: OrderEvent[],
): boolean {
  const incomingOrderId = incomingEvents[0]?.orderId;

  return (
    !!currentOrderId &&
    !!incomingOrderId &&
    incomingOrderId !== currentOrderId &&
    incomingEvents.length === 1 &&
    incomingEvents[0].action === OrderAction.ORDER_INITIATE
  );
}
